'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var OMW = function OMW(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    fill: "none",
    d: "M17.963,16.009c-0.786,0-1.67,0.645-1.979,1.441c-0.308,0.797,0.076,1.441,0.862,1.441 c0.784,0,1.67-0.645,1.979-1.441C19.134,16.653,18.749,16.009,17.963,16.009z"
  }), React__default["default"].createElement("path", {
    fill: "none",
    d: "M6.6,16.009c-0.786,0-1.669,0.645-1.979,1.441c-0.309,0.797,0.076,1.441,0.862,1.441 c0.785,0,1.67-0.645,1.979-1.441S7.386,16.009,6.6,16.009z"
  }), React__default["default"].createElement("polygon", {
    fill: "none",
    points: "19.25,10.243 18.317,12.646 18.656,12.646 22.541,12.646 21.618,10.243 \t"
  }), React__default["default"].createElement("path", {
    d: "M22.65,8.802h-1.758h-1.084h-1.912l-1.511,3.844h-2.145l3.021-7.688H9.958H9.098H6.156L5.459,6.76 C5.441,6.801,5.417,6.839,5.401,6.88L5.379,6.938L1.307,17.45h1.895c-0.619,1.596,0.151,2.883,1.723,2.883 c1.572,0,3.34-1.287,3.957-2.883h5.683c-0.617,1.596,0.151,2.883,1.724,2.883s3.339-1.287,3.957-2.883h1.894L24,12.646L22.65,8.802 z M7.461,17.45c-0.309,0.797-1.193,1.441-1.979,1.441c-0.786,0-1.171-0.645-0.862-1.441c0.311-0.797,1.193-1.441,1.979-1.441 S7.77,16.653,7.461,17.45z M18.824,17.45c-0.309,0.797-1.194,1.441-1.979,1.441c-0.786,0-1.17-0.645-0.862-1.441 c0.31-0.797,1.193-1.441,1.979-1.441S19.134,16.653,18.824,17.45z M18.656,12.646h-0.339l0.933-2.402h2.368l0.923,2.402H18.656z"
  }), React__default["default"].createElement("path", {
    d: "M0.76,7.958v1.979h2.181L2.964,9.88c0.016-0.041,0.04-0.079,0.058-0.12l0.697-1.802H0.76z"
  }), React__default["default"].createElement("path", {
    d: "M0.063,9.76C0.045,9.801,0.021,9.839,0.005,9.88l-0.022,0.058H0.76V7.958L0.063,9.76z"
  }), React__default["default"].createElement("path", {
    d: "M0.76,4.958L0.063,6.76C0.045,6.801,0.021,6.839,0.005,6.88l-0.022,0.058H0.76h3.351L4.134,6.88 c0.016-0.041,0.04-0.079,0.058-0.12l0.697-1.802H0.76z"
  }));
};

var OMW$1 = iconStyles()(OMW);

module.exports = OMW$1;
